(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["exp-contact-form-address"] && !Shopify.designMode) return;
  try {
    
  // Track page load time for anti-spam submit_time
  window.__contactFormLoadTime = Date.now();

  // Proxy URL (replace with your Vercel deployment URL)
  const PROXY_URL = 'https://salesforce-anti-spam-proxy-bycleant.vercel.app';

  document.addEventListener('DOMContentLoaded', function () {
    // Initialize SlimSelect for country dropdown
    function initSlimSelect() {
      const selectEl = document.querySelector('#ContactForm-country');
      if (!selectEl) return;
      new SlimSelect({
        select: '#ContactForm-country',
        settings: {
          showOptionTooltips: true,
          placeholderText: ':: Select Country',
          allowDeselect: false,
        },
      });
    }

    try {
      initSlimSelect();
    } catch (err) {
      console.warn('SlimSelect initialization failed for contact form, will retry:', err.message);
      setTimeout(() => {
        try {
          initSlimSelect();
        } catch (retryErr) {
          console.error('SlimSelect retry also failed:', retryErr.message);
        }
      }, 1500);
    }
    const sfForm = document.getElementById('sf-contact-form');
    if (sfForm) {
      sfForm.addEventListener('submit', async function (e) {
        e.preventDefault();

        const submitBtn = document.getElementById('contact-submit-btn');
        const successMsg = document.getElementById('contact-form-success');
        const spamError = document.getElementById('contact-form-spam-error');

        // Hide previous messages
        if (successMsg) successMsg.style.display = 'none';
        if (spamError) spamError.style.display = 'none';

        // Loading state
        const originalBtnText = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending...';
        submitBtn.style.opacity = '0.7';

        try {
          // Collect all form data
          const formDataObj = {};
          const formData = new FormData(sfForm);
          for (const [key, value] of formData.entries()) {
            formDataObj[key] = value;
          }

          // Add retURL for Salesforce
          formDataObj.retURL = window.location.origin + window.location.pathname;

          // Calculate submit time (seconds since page load)
          const submitTime = Math.round((Date.now() - window.__contactFormLoadTime) / 1000);

          const payload = {
            formData: formDataObj,
            senderEmail: formDataObj.email || '',
            senderName: (formDataObj.first_name || '') + ' ' + (formDataObj.last_name || ''),
            message: formDataObj.description || '',
            submitTime: submitTime,
          };

          const response = await fetch(PROXY_URL + '/api/webhook/lead', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });

          const result = await response.json();

          if (result.success) {
            if (typeof gtag !== 'undefined') {
              gtag('event', 'lead_form_submit', {
                form_id: 'sf-contact-form',
                form_location: 'contact-page',
                product_name: ''
              });
            }
            console.log('[QT] lead_form_submit fired - contact form');
            // Show success message
            if (successMsg) {
              successMsg.style.display = 'flex';
              successMsg.focus();
            }
            sfForm.reset();
          } else if (result.spam) {
            // Silently show generic error (don't reveal spam detection)
            if (spamError) {
              spamError.style.display = 'flex';
              spamError.focus();
            }
          } else {
            if (spamError) {
              spamError.style.display = 'flex';
              spamError.focus();
            }
          }
        } catch (err) {
          console.error('Form submission error:', err);
          // On network error, show error message
          const spamError = document.getElementById('contact-form-spam-error');
          if (spamError) {
            spamError.style.display = 'flex';
            spamError.focus();
          }
        } finally {
          submitBtn.disabled = false;
          submitBtn.textContent = originalBtnText;
          submitBtn.style.opacity = '1';
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
